import { render } from "./PopUpMerge.vue?vue&type=template&id=cc99af96"
import script from "./PopUpMerge.vue?vue&type=script&lang=js"
export * from "./PopUpMerge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__